import { rockApi, unwrapRockResponse } from "./rockApiClient";

export const rockGemsApi = {
  async getStatistics() {
    const resp = await rockApi.get("/rocks/gems/statistics");
    return unwrapRockResponse(resp);
  },

  async getCategories() {
    const resp = await rockApi.get("/rocks/gems/categories");
    return unwrapRockResponse(resp);
  },

  async getGems({ category_uid, page = 1, items_per_page = 20 }) {
    const resp = await rockApi.get("/rocks/gems", {
      params: { category_uid, page, items_per_page }
    });
    return unwrapRockResponse(resp);
  },

  /** Grouped list: months × gems (includes intro row with `uid: "default"`). */
  async getGemsBirthstones() {
    const resp = await rockApi.get("/rocks/gems/birthstones");
    return unwrapRockResponse(resp);
  },

  /** Grouped list: zodiac signs × gems (includes intro row with `uid: "default"`). */
  async getGemsZodiac() {
    const resp = await rockApi.get("/rocks/gems/zodiac");
    return unwrapRockResponse(resp);
  },

  /** Paginated gem list. Optional `name`, `source`, `language_code` (2-letter catalog lang). */
  async getGemsList({ name, source, language_code, page = 1, items_per_page = 20 } = {}) {
    const params = { page, items_per_page };
    const nameVal = typeof name === "string" ? name.trim() : "";
    if (nameVal) params.name = nameVal;
    if (source) params.source = source;
    if (language_code) params.language_code = language_code;
    const resp = await rockApi.get("/rocks/gems/list", { params });
    return unwrapRockResponse(resp);
  },

  async getGemDetail({ uid, category_uid, language_code }) {
    const params = { uid, category_uid };
    if (language_code) params.language_code = language_code;
    const resp = await rockApi.get("/rocks/gems/detail", { params });
    return unwrapRockResponse(resp);
  }
};

